import { atom } from "jotai";

export type State = {
  activeModal?: "listing" | "detail";
  isShowDetailListingPopup?: boolean;
  isShowPopup?: boolean;
  originalUrl?: string;
} | null;

export const plusArticlePopupAtom = atom<State>(null);
